export enum FastAccessEnum {
  Invoice = 1,
  Salon = 2,
  DriverAssignment = 3,
  Customer = 4,
  Waiter = 5,
  pager = 6,
  club = 7,
  PaymentLink = 8,
  DelinoOfflineFactor = 9,
  PosScale = 10,
}
